import * as ActionTypes from '../actions/index';
import {LOGOUT} from "../actions";

const defaultState = {
    quotes: [],
    suggestions: [],
    suggestionFieldValue: '',
    brokerFilterSearchValue: '',
    fetching: false,
    viewAmount: 20,
    totalPaginationBoxes: 0,
    page: 1,
    totalRecords: 0,
    selectedQuoteStatuses: [],
    selectedPostcodes:[],
    selectedBrokerFirms:[],
	wasFilterButtonPressed: false
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case ActionTypes.CLEAR_QUOTES_FILTERS:
            return {
                ...state,
				selectedQuoteStatuses: defaultState.selectedQuoteStatuses,
				selectedPostcodes: defaultState.selectedPostcodes,
				suggestions: defaultState.suggestions,
				suggestionFieldValue: defaultState.suggestionFieldValue,
                selectedBrokerFirms:defaultState.selectedBrokerFirms,
				wasFilterButtonPressed: false
            }
        case ActionTypes.GET_QUOTES_SUGGESTIONS_SUCCESS:
            return {
                ...state,
                suggestions: action.payload.body.data
            };
        case ActionTypes.CHANGE_QUOTES_STATE:
            return {
                ...state,
                [action.payload.key]: action.payload.value
            };
        case ActionTypes.QUOTES_LIST_PAGE_SHIFT:
            if(action.payload === 'left' && state.page > 1){
                return {
                    ...state,
                    page: state.page - 1
                }
            }
            else if(action.payload === 'right' && state.page < state.totalPaginationBoxes) {
                return {
                    ...state,
                    page: state.page + 1,
                }
            }
            else {
                return state;
            }
        case ActionTypes.CHANGE_QUOTES_LIST_PAGE:
            return {
                ...state,
                page: action.payload.value,
            };
        case ActionTypes.GET_QUOTES:
            return {
                ...state,
                fetching: true
            };
        case ActionTypes.GET_QUOTES_SUCCESS:
            let totalDisplayBoxes = Math.ceil(action.payload.body.totalRecords / parseInt(state.viewAmount));
            let currentPage = parseInt(state.page);
            if(currentPage > totalDisplayBoxes && totalDisplayBoxes !== 0){
                currentPage = totalDisplayBoxes;
            }
            return {
                ...state,
                fetching: false,
                quotes: action.payload.body.data,
                totalRecords: action.payload.body.totalRecords,
                page: currentPage,
                totalPaginationBoxes: totalDisplayBoxes
            };
        case ActionTypes.GET_QUOTES_FAILED:
            return {
                ...state,
                fetching: false
            };
        case LOGOUT:
            return {
                ...defaultState
            };
        default:
            return state
    }
}